import { defaultstoreRoute } from './defaultstore'

export const allDefaultstoreRoutes = [defaultstoreRoute()]
